





















































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import OrganizationIcon from '@/components/common/OrganizationIcon.vue';
import { AccountParticipationOrganization } from '@/@types/Account';
import { vxm } from '@/store';
import { FindNotificationsDto } from '@/@types/Notification';

@Component({
  components: {
    OrganizationIcon,
  },
})
export default class CommonHeaderOrganizationMenu extends Vue {
  @Prop({ required: true, default: []})
  private participationOrganizations!: AccountParticipationOrganization[];
  private isOpenOrganizationList: boolean = false;
  private organizationAvatarSize: number = 32;
  private organizationAvatarColor: string = '#fdb44d';

  private async moveToOrganizationHome(organization: AccountParticipationOrganization) {
    vxm.theoryApi.authStore.fetchCurrentOrganizationId(organization.organizationId);
    vxm.theoryApi.authStore.fetchCurrentOrganizationName(organization.organizationName);
    await vxm.theoryApi.accountsStore.fetchAccountBasicParticipationProjects({
      accountId: this.accountId as number,
      organizationId: organization.organizationId,
    });
    const participationProjects = vxm.theoryApi.accountsStore.getAccountBasicParticipationProjects?.results;
    /**組織変更に合わせてカレントプロジェクトの情報、アクティビティ、通知を更新 */
    if (participationProjects) {
      const projectIds = participationProjects.map((project) => {
        return project.projectId;
      });
      vxm.theoryApi.authStore.fetchCurrentProjectIds(projectIds);
      if (participationProjects.length > 0) {
        vxm.theoryApi.authStore.fetchCurrentProjectId(participationProjects[0].projectId);
        vxm.theoryApi.authStore.fetchCurrentProjectName(participationProjects[0].projectName);
        const projectId = vxm.theoryApi.authStore.getCurrentProjectId as number;
        const notificationParams: FindNotificationsDto = {
          notificationTargetAccountId: this.accountId as number,
          organizationId: this.organizationId,
          actionAccountId: 2,
          unreadFlag: true,
        };
        /**カレントプロジェクトに関わる全てのstore情報を更新 */
        this.resetState();
        await Promise.all([
          vxm.theoryApi.projectsStore.fetchProjectBasic(projectId),
          vxm.theoryApi.projectMembersStore.fetchProjectMembersById(projectId),
          vxm.theoryApi.activitiesStore.fetchOrganizationActivities({
            projectIds: projectIds,
            organizationId: organization.organizationId
          }),
          vxm.theoryApi.activitiesStore.fetchProjectActivities({
            projectIds: [projectId],
            organizationId: organization.organizationId
          }),
          vxm.theoryApi.notificationsStore.fetchUnreadNotifications(notificationParams),
        ]);
        if (this.$route.name !== 'home') {
          this.$router.push({ name: 'home' });
        } else {
          this.changeProjects();
        }
        /**カレントプロジェクトが無い為、カレントプロジェクトに関わる全てのstore情報を削除 */
      } else {
        vxm.theoryApi.authStore.fetchCurrentProjectId(null);
        vxm.theoryApi.authStore.fetchCurrentProjectIds(null);
        vxm.theoryApi.authStore.fetchCurrentProjectName(null);
        vxm.theoryApi.projectsStore.deleteProjectBasic();
        vxm.theoryApi.projectMembersStore.deleteHomeProjectMembers();
        vxm.theoryApi.activitiesStore.deleteOrganizationActivities();
        vxm.theoryApi.activitiesStore.deleteProjectActivities();
        vxm.theoryApi.notificationsStore.deleteNotifications();
        vxm.theoryApi.notificationsStore.deleteUnreadNotifications();
        this.resetState();
        if (this.$route.name !== 'home') {
          this.$router.push({ name: 'home' });
        } else {
          this.changeProjects();
        }
      }
    }
  }

  private resetState() {
    vxm.theoryApi.directoriesStore.deleteDirectoriesAndFiles();
    vxm.theoryApi.directoriesStore.deleteParentDirectory();
    vxm.theoryApi.directoriesStore.deleteCurrentDirectory();
    vxm.theoryApi.projectMembersStore.deleteProjectMembers();
    vxm.theoryApi.projectsStore.deleteProject();
    vxm.theoryApi.projectsStore.deleteProjectAll();
    vxm.theoryApi.projectsStore.deleteTaskAttributeValueOptions();
    vxm.theoryApi.tasksStore.deleteTask();
    vxm.theoryApi.tasksStore.deleteTasks();
    vxm.theoryApi.tasksStore.deleteTaskComments();
  }

  private get accountId() {
    const response = vxm.theoryApi.authStore.getCurrentUserInfo;
    if (response) {
      return response.results.accountId;
    } else return null;
  }

  private get organizationId(): number | null {
    return vxm.theoryApi.authStore.getCurrentOrganizationId;
  }

  private get projectIds() {
    const response = vxm.theoryApi.authStore.getCurrentProjectIds;
    return response ? response : [];
  }

  private get currentOrganizationName() {
    const accountParticipationOrganizations = this.participationOrganizations;
    if (accountParticipationOrganizations) {
      for (const accountParticipationOrganization of accountParticipationOrganizations) {
        if (accountParticipationOrganization.organizationId === this.organizationId) {
          return accountParticipationOrganization.organizationName;
        }
      }
      return '';
    }

    return '';
  }

  @Emit('changeProjects')
  private changeProjects() {}
}
